<template>
	<div class="pageBox">
		<Header current='souye' ref="Header"></Header>
		<div class="pageBox_cen">
			<template v-for="(item,index) in list">
				<component :is="mapComponent[item.name]" :list='item' :ref="item.name"/>
			</template>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from "@/components/header.vue"
	import Footer from "@/components/footer.vue"
	import mapComponent from "@/components/mapComponent.js";
	import {
		get_banner,
	} from "@/api/index.js"
	import {
		get_campus_config
	} from "@/api/recruit.js"
	import {
		get_config
	} from "@/api/config.js"
	export default {
		components: {
			Header,
			Footer,
		},
		data() {
			return {
				mapComponent,
				list: [{
						name: 'recruitBanner',
						value: '招贤纳士轮播图',
						height:800,
						list: [
							// {
							// 	img: require("@/assets/content/gyah.png"),
							// 	name:'未来属于梦想家也属于你',
							// 	cen:'The future belongs to dreamers'
							// },
							// {
							// 	img: require("@/assets/content/gyah.png"),
							// 	name:'未来属于梦想家也属于你',
							// 	cen:'The future belongs to dreamers'
							// },
							// {
							// 	img: require("@/assets/content/gyah.png"),
							// 	name:'未来属于梦想家也属于你',
							// 	cen:'The future belongs to dreamers'
							// },
						],
						
					},
					{
						name: 'campusCen',
						value: '校园招聘内容',
					}
				],
				navHidden: false, // 导航栏是否隐藏
				lastScrollTop: 0, // 上一次页面滚动的位置
				currentRoute: '',
			}
		},

		mounted() {
			window.addEventListener('scroll', this.handleScroll);
			this.currentRoute = this.$route.path; // 初始化时获取当前路由地址
			this.$watch('$route', this.onRouteChange);
			var element;
			if(this.nowVibe=='pc'){
				element= document.documentElement
			}else{
				element = document.documentElement.scrollTop ? document.documentElement : document.body;
			}
			let scrollTop = element.scrollTop;
			if (scrollTop == 0) {
				if(!this.$refs.Header.navHead){
					this.$refs.Header.headerHover = false;
				}
				this.$refs.Header.headerTrue = false;
			} else {
				this.$refs.Header.headerTrue = true;
				this.$refs.Header.headerHover = true;
			}
			this.getBannerList(10);
			this.getConfig();
			this.getEmail();
			let locale = this.$i18n.locale;
			if(locale!='zh'){
				this.$router.push('/')
			}
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);

		},
		methods: {
			onRouteChange(newRoute, oldRoute) {
				this.currentRoute = newRoute.path; // 更新当前路由地址
				try{
					this.$refs.recruitCen[0].querValue = this.$route.query.value;
				}catch(e){
					//TODO handle the exception
				}
				// this.goScroll(this.$route.query.value)
			},
			handleScroll() {
				const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body
					.scrollTop || 0;
				if (currentScrollTop > this.lastScrollTop) {
					this.navHidden = true;
				} else {
					this.navHidden = false;
				}
				this.lastScrollTop = currentScrollTop;

				
				if (currentScrollTop == 0) {
					if(!this.$refs.Header.navHead){
						this.$refs.Header.headerHover = false;
					}
					this.$refs.Header.headerTrue = false;
				} else {
					this.$refs.Header.headerTrue = true;
					this.$refs.Header.headerHover = true;
				}
				try{
					this.$refs.recruitCen[0].navHidden = this.navHidden;
				}catch(e){
					//TODO handle the exception
				}
			},
			goScroll(e) {
				this.lastScrollTop = e;
				// document.documentElement.scrollTop = e + 10;
				var element;
				if(this.nowVibe=='pc'){
					element= document.documentElement
				}else{
					element = document.documentElement.scrollTop ? document.documentElement : document.body;
				}
					element.scrollTop =e+10;
			},
			// 获取轮播图
			getBannerList(e) {
				let t = this;
				let data = {
					module: e
				}
			
				get_banner(data).then((res) => {
					console.log(res)
					this.$nextTick(function() {
						t.$refs['recruitBanner'][0].setList(res.data);
					})
				}).catch((err) => {
					console.log(err)
				})
			},
			// 获取社会招聘配置页面
			getConfig(){
				let data={}
				get_campus_config(data).then(res=>{
					console.log(res,"社会招聘")
					this.$refs['campusCen'][0].setList(res.data.info)
				}).catch(err=>{
					console.log(err)
				})
			},
			// 获取HR联系方式
			getEmail(){
				let data={}
				get_config(data).then(res=>{
					console.log(res)
					this.$refs['campusCen'][0].email=res.data.hr_contact_email
				}).catch(err=>{
					console.log(err)
				})
			}
		},
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.pageBox {
		display: flex;
		flex-direction: column;
		min-height: 100vh;

		.pageBox_cen {
			flex: 1;
		}
	}
</style>